<template>
  <div class="container-fluid">
    <div class="contents tournament">
      <b-form @submit="onSubmit">
        <div class="profile border-top-dgray">
          <div class="row g-0 border-bottom" v-if="tournamentno !== 0">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.tournament.locaton") }}</label>
            </div>
            <div class="col-9">
              <div class="row g-0">
                <div class="col-8 d-table">
                  <p>{{ tournamentshopname }}</p>
                </div>
                <div class="col-4"></div>
              </div>
            </div>
          </div>

          <div class="row g-0 border-bottom">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.common.status") }}</label>
            </div>
            <div class="col-9">
              <div class="row g-0">
                <div class="col-8">
                  <select name="status" v-model="form.status" class="">
                    <option value="1">{{ $t("filter.common.ready") }}</option>
                    <option value="2">{{ $t("filter.common.playing") }}</option>
                    <option value="3">
                      {{ $t("filter.common.completed") }}
                    </option>
                    <option value="4">{{ $t("filter.common.cancel") }}</option>
                  </select>
                </div>
                <div class="col-4"></div>
              </div>
            </div>
          </div>

          <div class="row g-0 border-bottom">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.common.title") }}</label>
            </div>
            <div class="col-9">
              <div class="row g-0">
                <div class="col-8">
                  <input type="text" v-model="form.title" />
                </div>
                <div class="col-4"></div>
              </div>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.common.period") }}</label>
            </div>
            <div class="col-9">
              <div class="row g-0">
                <div class="col-8 period">
                  <input
                    type="date"
                    class="form-control-lg"
                    v-model="form.startdate"
                    format
                  />
                  <input
                    type="date"
                    class="form-control-lg"
                    v-model="form.enddate"
                  />
                </div>
                <div class="col-4"></div>
              </div>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.tournament.outline") }}</label>
            </div>
            <div class="col-9">
              <div class="row g-0">
                <div class="col-8">
                  <textarea
                    v-model="form.remark"
                    cols="30"
                    rows="10"
                    :placeholder="$t('text.tournament.cannot _exceed_100')"
                  ></textarea>
                </div>
                <div class="col-4"></div>
              </div>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.tournament.prizesetc") }}</label>
            </div>
            <div class="col-9">
              <div class="row g-0">
                <div class="col-8">
                  <textarea
                    v-model="form.etcprize"
                    cols="30"
                    rows="10"
                    :placeholder="$t('ranking_prize_pool_details')"
                  ></textarea>
                </div>
                <div class="col-4"></div>
              </div>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.tournament.prize_rank") }}</label>
            </div>
            <div class="col-9">
              <div class="row g-0">
                <div class="col-8">
                  <select
                    class=""
                    name="rankno"
                    v-model="form.rankno"
                    @change="input_rankno($event)"
                  >
                    <template v-for="(rank, index) in rank_count">
                      <option :value="rank" :key="index + 'r'">
                        {{ rank }}
                      </option>
                    </template>
                  </select>
                  <span class="text-blue">{{
                    $t("text.tournament.prize_rank")
                  }}</span>
                </div>
                <div class="col-4"></div>
              </div>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.tournament.prizes_bucks") }}</label>
            </div>
            <div class="col-9 bucks">
              <div class="row g-0">
                <template v-for="(rank, index) in rank_count">
                  <div
                    class="col-12 col-sm-4"
                    v-if="form.rankno >= rank"
                    :key="index + 'rp'"
                  >
                    <p>Top{{ rank }}</p>
                    <input
                      type="text"
                      :name="'rankprize' + rank"
                      v-model="form.rankprizelist.rankprize[index]"
                    /><small class="point">{{
                      $t("title.common.bucks")
                    }}</small>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label>{{ $t("title.tournament.conditions") }}</label>
            </div>
            <div class="col-9 wrap-col">
              <div class="row g-0">
                <div class="col-lg">
                  <p>{{ $t("title.tournament.wind_setting") }}</p>
                  <select name="wind" v-model="form.wind" class="">
                    <option value="0">{{ $t("filter.common.none") }}</option>
                    <option value="1">{{ $t("filter.common.slow") }}</option>
                    <option value="2">{{ $t("filter.common.middle") }}</option>
                    <option value="3">{{ $t("filter.common.strong") }}</option>
                    <option value="4">{{ $t("filter.common.random") }}</option>
                  </select>
                </div>
                <div class="col-lg">
                  <p>{{ $t("title.tournament.mulligan") }}</p>
                  <select name="mulligan" v-model="form.mulligan" class="">
                    <option value="0">{{ $t("filter.common.none") }}</option>
                  </select>
                </div>
                <div class="col-lg">
                  <p>{{ $t("title.tournament.maleteebox") }}</p>
                  <select name="teeboxman" v-model="form.teeboxman" class="">
                    <option value="1">
                      {{ $t("filter.common.pro_blue") }}
                    </option>
                    <option value="2">
                      {{ $t("filter.common.regular_white") }}
                    </option>
                    <option value="3">
                      {{ $t("filter.common.lady_red") }}
                    </option>
                    <option value="4">
                      {{ $t("filter.common.kids_yellow") }}
                    </option>
                  </select>
                </div>
                <div class="col-lg">
                  <p>{{ $t("title.tournament.femaleteebox") }}</p>
                  <select
                    name="teeboxwoman"
                    v-model="form.teeboxwoman"
                    class=""
                  >
                    <option value="1">
                      {{ $t("filter.common.pro_blue") }}
                    </option>
                    <option value="2">
                      {{ $t("filter.common.regular_white") }}
                    </option>
                    <option value="3">
                      {{ $t("filter.common.lady_red") }}
                    </option>
                    <option value="4">
                      {{ $t("filter.common.kids_yellow") }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row border-bottom">
            <div class="col-3 bg-gray row align-items-center">
              <label>Handicap(No. of Play)</label>
            </div>
            <div class="col-9 handicap">
              <div class="row">
                <div class="col">
                    <label class="form-check-label font-weight-bold font-14" for="flexCheck1">No.5</label>
                    <input class="form-check-input" type="text" name="playhandicap5" v-model="form.playhandicap5" id="flexCheck1">
                </div>
                <div class="col">
                    <label class="form-check-label font-weight-bold font-14" for="flexCheck2">No.10</label>
                    <input class="form-check-input" type="text" name="playhandicap10" v-model="form.playhandicap10" id="flexCheck2">
                </div>
                <div class="col">
                    <label class="form-check-label font-weight-bold font-14" for="flexCheck3">No.15</label>
                    <input class="form-check-input" type="text" name="playhandicap15" v-model="form.playhandicap15" id="flexCheck3">
                </div>
                <div class="col">
                    <label class="form-check-label font-weight-bold font-14" for="flexCheck4">No.20</label>
                    <input class="form-check-input" type="text" name="playhandicap20" v-model="form.playhandicap20" id="flexCheck4">
                </div>
                <div class="col">
                    <label class="form-check-label font-weight-bold font-14" for="flexCheck5">No.25</label>
                    <input class="form-check-input" type="text" name="playhandicap25" v-model="form.playhandicap25" id="flexCheck5">
                </div>
                <div class="col">
                    <label class="form-check-label font-weight-bold font-14" for="flexCheck6">No.30</label>
                    <input class="form-check-input" type="text" name="playhandicap30" v-model="form.playhandicap30" id="flexCheck6">
                </div>
                <div class="col">
                    <label class="form-check-label font-weight-bold font-14" for="flexCheck7">No.35</label>
                    <input class="form-check-input" type="text" name="playhandicap35" v-model="form.playhandicap35" id="flexCheck7">
                </div>
                <div class="col">
                    <label class="form-check-label font-weight-bold font-14" for="flexCheck8">No.40</label>
                    <input class="form-check-input" type="text" name="playhandicap40" v-model="form.playhandicap40" id="flexCheck8">
                </div>
                <div class="col">
                    <label class="form-check-label font-weight-bold font-14" for="flexCheck9">No.45</label>
                    <input class="form-check-input" type="text" name="playhandicap45" v-model="form.playhandicap45" id="flexCheck9">
                </div>
                <div class="col">
                    <label class="form-check-label font-weight-bold font-14" for="flexCheck10">No.50</label>
                    <input class="form-check-input" type="text" name="playhandicap50" v-model="form.playhandicap50" id="flexCheck10">
                </div>
              </div>
              <span class="text-blue">No.5 : 1, No.10 : 2 ... Deduct the number of rounds from the player’s score. When there are more than two courses are being selected for Tournaments, the number of rounds will be deducted from the lowest average score.</span>
            </div>
          </div> -->
          <div class="row g-0 border-bottom">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell last">{{
                $t("title.common.course")
              }}</label>
            </div>
            <div class="col-9">
              <p>
                <span
                  v-for="(cc, index) in form.courselist"
                  :key="index + 'cc'"
                >
                  {{ index > 0 ? ", " : "" }}
                  {{ tournamentcoursenamelist[cc] }}
                </span>
              </p>
              <span class="text-blue">{{
                $t("text.tournament.only_one_golfcourse")
              }}</span>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="$bvModal.show('exampleModal6')"
              >
                {{ $t("button.tournament.select_golfcourse") }}
              </button>
            </div>
          </div>
          <div class="row g-0 border-bottom">
            <div class="col-3 bg-gray row g-0 align-items-center">
              <label class="d-table-cell last lh-48">{{
                $t("title.tournament.subcourses")
              }}</label>
            </div>

            <div class="col-9">
              <div v-if="courseview_yn === 'y'">
                <div
                  class="row g-0 subcourse"
                  v-for="(anc, index1) in form.subcourselist"
                  :key="index1"
                >
                  <div class="col-lg">
                    <h6 class="pt-1">{{ anc.subcoursename }}</h6>
                    <small class="d-block text-dgray"
                      >{{ $t("title.tournament.subcourses") }}
                      {{ anc.subcourseseq }}</small
                    >
                  </div>
                  <div class="col-lg">
                    {{
                      form.subcoursetype[index1] == "1"
                        ? $t("title.common.Out")
                        : ""
                    }}
                    {{
                      form.subcoursetype[index1] == "2"
                        ? $t("title.common.In")
                        : ""
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            aria-label="list"
            @click="$router.push({ name: 'TournamentList' })"
            >{{ $t("button.common.list") }}</b-button
          >
          <b-button
            size="xl"
            variant="primary"
            aria-label="modify register"
            type="submit"
            >{{
              tournamentno ? $t("button.common.save") : $t("button.common.save")
            }}</b-button
          >
        </div>
      </b-form>
    </div>

    <b-modal
      id="exampleModal6"
      class="select-course"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ $t("button.tournament.select_golfcourse") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="close()"
        ></b-button>
      </template>
      <b-form-group>
        <b-form-checkbox-group
          v-model="form.courselist"
          name="courselist"
          class="row"
        >
          <div
            class="d-flex col-4 mb-3"
            :key="index + 'cl'"
            v-for="(course, index) in tournamentcourselist"
          >
            <div class="flex-shrink-0">
              <b-form-checkbox
                class="form-check"
                :value="course.maincourseno"
                @change="chk_mc()"
              >
              </b-form-checkbox>
            </div>
            <div class="flex-grow-1 mx-2 pe-4 align-self-center text-break">
              {{ course.coursename }}
            </div>
          </div>
        </b-form-checkbox-group>
      </b-form-group>
      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          aria-label="confirm"
          @click="cancel()"
          >{{ $t("button.common.apply") }}</b-button
        >
      </template>
      <!--       <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          type="button"
          variant="primary"
          @click="cancel()"
          class="btn1"
        >
          확인
        </b-button>
      </template> -->
    </b-modal>
  </div>
</template>

<script>
import commonDatePicker from "@/components/common/datepicker/Picker";
import "@/filter/common";
import ax from "@/api/tournament";

export default {
  name: "Write",
  data() {
    return {
      tournamentno: this.$route.params.tournamentno || 0,
      tournamentshopname: "",
      form: {
        title: "",
        startdate: "",
        enddate: "",
        remark: "",
        etcprize: "",

        rankno: 1,
        rankprizelist: [],
        wind: 0,
        mulligan: 0,
        teeboxman: 1,
        teeboxwoman: 1,
        // playhandicap5: 0,
        // playhandicap10: 0,
        // playhandicap15: 0,
        // playhandicap20: 0,
        // playhandicap25: 0,
        // playhandicap30: 0,
        // playhandicap35: 0,
        // playhandicap40: 0,
        // playhandicap45: 0,
        // playhandicap50: 0,
        courselistcnt: 0,
        courselist: [],
        subcourselistcnt: 0,
        subcourselist: [],
        subcoursetype: [],
        status: 1,
      },
      tournamentcourselist: [],
      tournamentcoursenamelist: [],
      rank_count: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
        39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
      ],
      courseview_yn: "n",
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      if (this.form.title === "") {
        alert(this.$i18n.t("alert.tournament.enter_name_of_tournament"));
        return false;
      }
      if (this.form.startdate === "") {
        alert(this.$i18n.t("alert.tournament.enter_tournament_start_date"));
        return false;
      }
      if (this.form.enddate === "") {
        alert(this.$i18n.t("alert.tournament.enter_end_date_tournament"));
        return false;
      }
      if (this.form.remark === "") {
        alert(this.$i18n.t("alert.tournament.enter_tournament_information"));
        return false;
      }
      if (this.form.etcprize === "") {
        alert(
          this.$i18n.t("alert.tournament.enter_other_presentation_details")
        );
        return false;
      }

      for (let i = 0; i < this.form.rankno; i++) {
        if (
          this.form.rankprizelist.rankprize[i] === "" ||
          !this.form.rankprizelist.rankprize[i]
        ) {
          alert(this.$i18n.t("alert.tournament.enter_award_bucks"));
          return false;
        }
      }
      if (this.form.courselistcnt < 1) {
        alert(this.$i18n.t("alert.tournament.select_golf_course"));
        return false;
      }
      if (this.tournamentno === 0) {
        // 등록
        ax.set_ownertournamentwrite(this.form, (flag, data) => {
          alert(data.message);
          if (flag) {
            this.$router.push({ name: "TournamentList" });
          } else {
            this.$notify({
              group: "alert",
              type: "warn",
              title: "Notice",
              text: data,
            });
            return false;
          }
        });
      } else {
        // 수정
        ax.set_ownertournamentedit(
          this.form,
          this.tournamentno,
          (flag, data) => {
            alert(data.message);
            if (flag) {
              //location.reload()
            } else {
              return false;
            }
          }
        );
      }
    },
    startDateChange(v) {
      this.form.startdate = v;
    },
    endDateChange(v) {
      this.form.enddate = v;
    },
    get_ownertournamentview() {
      ax.get_ownertournamentview(this.tournamentno, (flag, data) => {
        console.log(flag, data);
        if (flag) {
          this.tournamentshopname = data.tournamentinfo.shopname;
          this.form.title = data.tournamentinfo.title;
          this.form.remark = data.tournamentinfo.remark;
          this.form.startdate = this.$dayjs(
            data.tournamentinfo.timezone_startdate
          ).format("YYYY-MM-DD");
          this.form.enddate = this.$dayjs(
            data.tournamentinfo.timezone_enddate
          ).format("YYYY-MM-DD");
          this.form.etcprize = data.tournamentprizeetc.etcprize;
          this.form.rankno = data.tournamentprizerankcnt;
          for (let i = 0; i < data.tournamentprizerank.length; i++) {
            // this.form.rankprizelist.rankno[i] = data.tournamentprizerank[i][`rankno[${i}]`]
            // this.form.rankprizelist.rankprize[i] = data.tournamentprizerank[i][`rankprize[${i}]`]

            this.form.rankprizelist.rankprize[i] =
              data.tournamentprizerank[i].rankprize;
          }

          this.form.wind = data.tournamentdetail.wind;
          this.form.mulligan = data.tournamentdetail.mulligan;
          this.form.teeboxman = data.tournamentdetail.teeboxman;
          this.form.teeboxwoman = data.tournamentdetail.teeboxwoman;
          // this.form.playhandicap5 = data.tournamentdetail.playhandicap5
          // this.form.playhandicap10 = data.tournamentdetail.playhandicap10
          // this.form.playhandicap15 = data.tournamentdetail.playhandicap15
          // this.form.playhandicap20 = data.tournamentdetail.playhandicap20
          // this.form.playhandicap25 = data.tournamentdetail.playhandicap25
          // this.form.playhandicap30 = data.tournamentdetail.playhandicap30
          // this.form.playhandicap35 = data.tournamentdetail.playhandicap35
          // this.form.playhandicap40 = data.tournamentdetail.playhandicap40
          // this.form.playhandicap45 = data.tournamentdetail.playhandicap45
          // this.form.playhandicap50 = data.tournamentdetail.playhandicap50
          this.form.courselistcnt = data.tournamentcoursecnt;
          this.form.courselist = [];
          for (let j = 0; j < data.tournamentcourse.length; j++) {
            //this.form.tournamentcourselist[j] = data.tournamentcourse[j][`courseno[${j}]`]
            this.form.courselist[j] = data.tournamentcourse[j].courseno;
            this.get_ownertournamentsubcourselist(this.form.courselist[j]);
          }

          this.courseview_yn = "y";
          this.form.status = data.tournamentinfo.status;
        } else {
          alert(data);
        }
      });
    },
    get_ownertournamentcourselist() {
      ax.get_ownertournamentcourselist(this.tournamentno, (flag, data) => {
        console.log(flag, data);
        if (flag) {
          this.tournamentcourselist = data.courselist;
          for (let i = 0; i < data.courselist.length; i++) {
            this.tournamentcoursenamelist[data.courselist[i].maincourseno] =
              data.courselist[i].coursename;
          }
        } else {
          alert(data.message);
        }
      });
    },
    chk_mc() {
      if (this.form.courselist.length > 1) {
        alert(this.$i18n.t("alert.tournament.only_one_course_canbe_selected"));
        this.form.courselist = this.form.courselist.slice(0, 1);
      }
      this.form.courselistcnt = this.form.courselist.length;

      if (this.form.courselistcnt > 0) {
        this.get_ownertournamentsubcourselist(this.form.courselist);
        this.courseview_yn = "y";
      } else {
        this.courseview_yn = "n";
      }
    },
    get_ownertournamentsubcourselist(courseno) {
      ax.get_ownertournamentsubcourselist(courseno, (flag, data) => {
        console.log(flag, data);
        if (flag) {
          this.form.subcourselist = data.subcourselist;
          this.form.subcourselistcnt = data.subcourselist.length;

          for (let i = 0; i < this.form.subcourselist.length; i++) {
            this.form.subcoursetype[i] = data.subcourselist[i].subcourseseq;
          }
        } else {
          alert(data.message);
        }
      });
    },
    input_rankno(event) {},
  },
  created() {
    this.get_ownertournamentcourselist();
    this.form.rankno = 1;
    this.form.rankprizelist.rankprize = [];

    if (this.tournamentno !== 0) {
      this.get_ownertournamentview();
    }
  },
};
</script>
